export default {"src":"/_next/static/media/tick.da5ce7f0.svg","height":16,"width":16};